import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const FEATURES = [
  "Official MPB sanctioned fighter status",
  "Scheduled bouts in your Locker Room",
  "Official W-L-D record kept by the committee",
  "Masters division title bout eligibility",
];

export default function License() {
  return (
    <section id="sanctioning" className="py-24 lg:py-32" data-testid="license-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-6"
        >
          <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#E10600] uppercase mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#E10600]" /> Fighter Registration
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white">
            Step back <span className="text-[#E10600]">through the ropes</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-xl">
            Applications are reviewed by the MPB sanctioning committee. Your professional record is checked
            against our matchmaking parity standard before any license is issued.
          </p>
          <ul className="mt-8 space-y-3">
            {[
              "Open to professionals and freshers aged 40–55",
              "Pro record (W-L-D) or a fresh 0-0-0 start",
              "Full medical protocol applies before licensure",
            ].map((t, i) => (
              <motion.li
                key={t}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 + i * 0.1, duration: 0.6 }}
                className="flex items-center gap-3 text-zinc-300 text-sm sm:text-base"
              >
                <span className="h-2 w-2 rotate-45 bg-[#E10600] shrink-0" /> {t}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="relative border border-[#E10600]/40 bg-[#141414] p-8 sm:p-10" data-testid="license-card">
            <div className="absolute inset-0 border border-[#E10600]/20 translate-x-2 translate-y-2 -z-10" />
            <span className="font-display text-6xl sm:text-7xl leading-none text-white uppercase">Fighter<br />Sanctioning</span>
            <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.35em] text-[#E10600] uppercase mt-4">
              Committee Reviewed · No Fees To Apply
            </p>
            <p className="text-sm text-zinc-400 leading-relaxed mt-4">
              Submit your application and the MPB sanctioning committee checks your record against the
              matchmaking parity standard. Once approved, your bouts are scheduled by the committee and your
              official record is tracked in your Locker Room.
            </p>
            <ul className="mt-6 space-y-2.5">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-zinc-300">
                  <Check className="h-4 w-4 text-[#E10600] mt-0.5 shrink-0" /> {f}
                </li>
              ))}
            </ul>
            <Link
              to="/register"
              data-testid="license-cta-register"
              className="mt-8 block text-center font-cond font-semibold tracking-[0.2em] bg-[#E10600] hover:bg-[#C00500] text-white px-8 py-4 transition-colors duration-300"
            >
              SUBMIT REGISTRATION
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
